import type { AppData } from "@/application/types";

export default {
  title: "4YourPlan",
  landingPage: { name: "tenantAdmin.index" },
  vuetifyOptions: {},
} satisfies AppData;
